import React from 'react';
import Crystalogram from './Crystalogram';
import { useTranslation } from 'react-i18next';
import styles from './Current.module.css'; // Предполагается, что у вас есть CSS модуль

const Current = () => {
  const { t } = useTranslation();

  return (
    <div className={styles.container}>
      {/* Уменьшаем размер заголовка для мобильных устройств */}
      <h2 className="text-2xl md:text-4xl font-bold mb-4 md:mb-6 text-white">{t('next_goals.title')}</h2>

      <div className="bg-white bg-opacity-20 rounded-lg p-4 md:p-6 mb-6 md:mb-8">
        {/* Уменьшаем размер текста описания */}
        <p className="text-base md:text-lg mb-3 md:mb-4 text-white">{t('next_goals.description')}</p>
        {/* Уменьшаем размер текста в списке */}
        <ul className="list-disc list-inside space-y-1 md:space-y-2 text-white text-sm md:text-base">
          <li>{t('next_goals.option1')}</li>
          <li>{t('next_goals.option2')}</li>
          <li>{t('next_goals.option3')}</li>
        </ul>
        {/* Уменьшаем размер текста заключения */}
        <p className="mt-3 md:mt-4 text-base md:text-lg font-semibold text-white">{t('next_goals.conclusion')}</p>
      </div>

      <div className="space-y-4 md:space-y-6">
        <Crystalogram title={`${t('next_goals.goal1')} (${t('next_goals.duration1')})`} />
        {/* <Crystalogram title={`${t('next_goals.goal2')} (${t('next_goals.duration2')})`} /> */}
        {/* <Crystalogram title={`${t('next_goals.goal3')} (${t('next_goals.duration3')})`} /> */}
      </div>
    </div>
  );
};

export default Current;